//
//
//
//
//
//
//
//
//
//
//
//

export default {
    mounted() {
        if (this.$route.path.includes('locations')) {
            document.querySelector('.callout-section')?.classList.add('location-page')
        }
    },
    data() {
        return {
            bgImage: this.blok ? (this.blok.background_image ? (this.blok.background_image.filename ? 'background-image:url(' + this.blok.background_image.filename + ')' : null) : null) : null,
        }
    },
    props: {
        blok: {
            type: Object,
            default: () => { }
        }
    }
}
